// extracted by mini-css-extract-plugin
export var cardContainer = "_ql-0";
export var cardHeader = "_ql-2";
export var collapsedState = "_ql-3";
export var dragHandle = "_ql-5";
export var dragHandleIcon = "_ql-6";
export var dragging = "_ql-1";
export var titleArea = "_ql-4";